import * as React from 'react';
import './style.scss';

const SplitContent = props => {
  return (
    <div className={`split-content ${props.isReversed ? 'is-reversed' : ''}`}>
      <div className="content" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
        {props.children}
      </div>
      <div className="image" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
        {props.image}
      </div>
    </div>
  );
};

export default SplitContent;
